import { RequireOnly } from '@pelicargo/types';
import { ensureDimensionUnit, getHandlingAndPacking, getPrettyDimensionUnit, prettyNumber } from '@pelicargo/utils';
import { Cargo, DimensionUnit } from '@prisma/client';

export const summaryLine = (
  cargo: RequireOnly<Cargo, 'quantity' | 'length' | 'width' | 'height' | 'weight' | 'handling'>,
  dimensionUnit: DimensionUnit,
) => {
  const dimensions = [cargo.length, cargo.width, cargo.height]
    .map((value) => prettyNumber(ensureDimensionUnit(value, dimensionUnit)))
    .join('×');

  return [
    `${prettyNumber(cargo.quantity)} Pcs`,
    `${dimensions} ${getPrettyDimensionUnit(dimensionUnit)}`,
    `${prettyNumber(cargo.weight)} kg`,
    getHandlingAndPacking(cargo),
  ]
    .filter(Boolean)
    .join(' | ');
};
